import { Component, OnInit, ViewChild } from "@angular/core";
import { Location, PopStateEvent } from "@angular/common";
import { Router, NavigationEnd, Event } from "@angular/router";
import { filter, Subscription } from "rxjs";
import { NavbarSuperAdminComponent } from "app/shared/navbar/navbar-superadmin/navbar-superadmin.component";
import { TabInfo } from "app/interfaces/tab-routes.interface";

@Component({
  selector: "superadmin-layout",
  templateUrl: "./superadmin-layout.component.html",
})
export class SuperAdminLayoutComponent implements OnInit {
  private _router: Subscription;
  menuItems: TabInfo[];

  url: string;
  location: Location;
  private lastPoppedUrl: string;
  private yScrollStack: number[] = [];
  @ViewChild("sidebar", { static: false }) sidebar;
  @ViewChild(NavbarSuperAdminComponent, { static: false })
  navbar: NavbarSuperAdminComponent;
  constructor(private router: Router, location: Location) {
    this.location = location;
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.insertTabs(this.router.url);
      }
    });
  }

  ngOnInit() {
    const elemMainPanel = <HTMLElement>document.querySelector(".main-panel");
    const elemSidebar = <HTMLElement>(
      document.querySelector(".sidebar .sidebar-wrapper")
    );
    this.location.subscribe((ev: PopStateEvent) => {
      this.lastPoppedUrl = ev.url;
    });
    const html = document.getElementsByTagName("html")[0];
    this._router = this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (this.navbar) {
          this.navbar.sidebarClose();
        }
      });
  }

  insertTabs(currentUrl) {
    this.menuItems = [];
    /* let showTabsPeople = currentUrl.startsWith(
      "/superadmin-panel/admin/people"
    );

    if (showTabsPeople) {
      this.menuItems = TABSADMIN_PEOPLE.filter((menuItem) => menuItem);
    } else {
    } */
  }
}
